<template>
  <vx-card :title="title" v-if="fileMultipleInstance !== null">
    <div class="multiple-file-upload">
      <input class="file-input-multiple" type="file" multiple :accept="accept" @change="multipleUploadHandler"
        ref="fileInputMultiple">

      <vs-list v-if="fileMultipleInstance.items.length > 0">
        <template v-for="item in fileMultipleInstance.items">
          <vs-tooltip :text="item.errorMessage" v-if="item.hasError">
            <vs-list-item :class="{ 'danger': item.hasError === true }" :icon="item.icon" color="primary"
              :title="item.fileName" />
          </vs-tooltip>
          <vs-list-item v-else :class="{ 'danger': item.hasError === true }" :icon="item.icon" color="primary"
            :title="item.fileName" />
        </template>
      </vs-list>

      <vs-alert v-else>
        Seleccione los archivos que desea cargar.
      </vs-alert>


      <div class="flex gap-2 mt-4">
        <vs-button icon="cloud_upload" @click="openFileDialogHandler" color="dark">
          Cargar archivos
        </vs-button>

        <vs-button icon="bolt" :disabled="fileMultipleInstance.items.length === 0" @click="startUploadingHandler()">
          Iniciar carga
        </vs-button>
      </div>
    </div>
  </vx-card>
</template>
<script>
export class FileMultiple {
  constructor() {
    this.items = [];
  }

  addItem(item) {
    this.items.push(item)
  }

  async start(endpoint, params, callback) {
    let itemsPending = this.items.filter((i) => i.startUploading === false)
    if (itemsPending.length > 0) {
      let response = await itemsPending[0].start(endpoint, params);
      callback(response)
      await this.start(endpoint, params, callback)
    }
  }
}
export class FileItem {
  /**
   * @param {string} fileName
   * @param {number} sizeInKb
   * @param {string} type
   * @param {object} fileRaw
   * @param {string} icon
   */
  constructor(fileName, sizeInKb, type, fileRaw, icon = "cloud_upload") {
    this.fileName = fileName;
    this.size = sizeInKb;
    this.type = type;
    this.icon = icon;
    this.fileRaw = fileRaw;
    this.startUploading = false;
    this.hasError = false;
    this.errorMessage = null;
  }

  async start(endpoint, params) {
    this.startUploading = true;
    this.icon = "cached";
    let formData = new FormData();
    formData.append('file', this.fileRaw)

    if (params) {
      for (let key in params) {
        formData.append(key, params[key])
      }
    }

    try {
      let response = await axios.post(endpoint, formData)
      this.icon = "check";
      return response;
    } catch (e) {
      this.icon = "close"
      this.hasError = true;
      this.errorMessage = e.response.data.error;
    }
  }
}

export default {
  name: "FileMultipleInput",
  data: () => ({
    items: [],
    fileMultipleInstance: null
  }),
  props: {
    title: {
      type: String
    },
    accept: {
      type: String
    },
    uploadUri: {
      required: true,
      type: String
    },
    params: {
      type: Object
    }
  },
  mounted() {
    this.fileMultipleInstance = new FileMultiple();
  },
  methods: {
    openFileDialogHandler() {
      this.$refs.fileInputMultiple.click();
    },
    multipleUploadHandler(ev) {
      this.message = ev.target.files;
      this.items = [];
      for (let f of ev.target.files) {
        this.fileMultipleInstance.addItem(
          new FileItem(f.name, f.size / 1000, f.type, f)
        )
      }
    },
    async startUploadingHandler() {
      this.$vs.loading();
      try {
        await this.fileMultipleInstance.start(
          this.uploadUri,
          this.params,
          (response) => this.$emit('onUpload', response.data)
        )
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>
<style scoped>
.file-input-multiple {
  display: none;
}
</style>